/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Theme from '../../ui/Theme';
import CloudIcon from '../../../assets/UploadIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  btnStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: Theme.palette.primary.main,
  },
}));

export default function UploadCsvButton({ name, id, handleCsvUpload, styles, disabled }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        name={name}
        accept=".csv"
        className={classes.input}
        id={id ?? 'upload-csv'}
        multiple
        onChange={handleCsvUpload}
        type="file"
        disable={disabled}
      />
      <label htmlFor={id ?? 'upload-csv'}>
        <Button
          startIcon={<CloudIcon />}
          variant="contained"
          style={styles}
          disableElevation
          component="span"
          disable={disabled}
        >
          <div className={classes.btnStyle}>Upload</div>
        </Button>
      </label>
    </div>
  );
}
